export const constants = {
	errorBoundaryMessage: "Sorry... Something went wrong, Please refresh or try again later.",
	noPageAccessHeader: "Sorry! You don't have access to this page",
	noPageAccessMessage: "You don't have permission to access this page. Please contact administrator.",
	backToHome: "Back to Homepage",
	pageNotFoundHeader: "Oops! Page Not found",
	pageNotFoundMessage: "We are sorry but the page you are looking for doesn’t exist or has been moved",
};
